import { Payable } from '@/types/finance/payable';
import dayjs from 'dayjs';

const payableTypes: Array<'maintenance' | 'vendor' | 'asset' | 'employee' | 'payroll' | 'other'> = ['maintenance', 'vendor', 'asset', 'employee', 'payroll', 'other'];
const payableStatuses: Array<'pending' | 'partial' | 'paid' | 'overdue' | 'cancelled'> = ['pending', 'partial', 'paid', 'overdue', 'cancelled'];
const vendorNames = [
  'ABC Mantenimiento Co.', 'Servicios Públicos de la Ciudad', 'Seguros State Farm', 'Oficina de Impuestos Local', 'Smith & Asociados Abogados',
  'Servicios Clean Pro', 'Seguridad Guard Inc.', 'Jardinería Green Thumb', 'Soluciones de Mercadeo LLC', 'Contratistas Generales',
  'Plomería Plus', 'Expertos Eléctricos', 'Especialistas HVAC', 'Maestros de Techado', 'Profesionales de Pintura',
  'Limpieza de Alfombras Inc.', 'Reparación de Ventanas Co.', 'Reparadores de Electrodomésticos', 'Control de Plagas Plus', 'Sistemas de Seguridad contra Incendios'
];

const amounts = [500, 750, 1000, 1500, 2000, 2500, 3000, 3500, 4000, 5000];

export const payables: Payable[] = Array.from({ length: 50 }, (_, idx) => {
  const typeIndex = idx % payableTypes.length;
  const statusIndex = idx % payableStatuses.length;
  const vendorIndex = idx % vendorNames.length;
  const amountIndex = idx % amounts.length;
  
  const dueDate = dayjs().add(Math.floor(Math.random() * 30), 'days').toDate();
  const createdAt = dayjs().subtract(Math.floor(Math.random() * 60), 'days').toDate();
  const paidAt = payableStatuses[statusIndex] === 'paid' ? dayjs().subtract(Math.floor(Math.random() * 30), 'days').toDate() : undefined;
  
  return {
    id: `PAY${(idx + 1).toString().padStart(3, '0')}`,
    name: `${payableTypes[typeIndex]} - ${vendorNames[vendorIndex]}`,
    description: `Servicio de ${payableTypes[typeIndex]} de ${vendorNames[vendorIndex]}`,
    amount: {
      amount: amounts[amountIndex] + Math.floor(Math.random() * 500),
      currency: 'USD'
    },
    type: payableTypes[typeIndex],
    status: payableStatuses[statusIndex],
    dueDate,
    paidAt,
    vendor: {
      id: `VEN${(vendorIndex + 1).toString().padStart(3, '0')}`,
      name: vendorNames[vendorIndex]
    },
    workspace: {
      id: 'demo-workspace',
      name: 'Jardines Sunset',
      slug: 'demo-workspace'
    },
    createdAt,
    updatedAt: paidAt || createdAt,
    activityRecords: [
      {
        timestamp: createdAt,
        type: 'created',
        performedBy: {
          id: 'user-1',
          name: 'Admin User',
          displayName: 'Admin User'
        }
      },
      ...(paidAt ? [{
        timestamp: paidAt,
        type: 'updated' as const,
        performedBy: {
          id: 'user-1',
          name: 'Admin User',
          displayName: 'Admin User'
        },
        details: 'Pago enviado'
      }] : [])
    ]
  };
}); 